import { render, staticRenderFns } from "./DNSProcessErrorContainer.vue?vue&type=template&id=3a3f833d&scoped=true&lang=html&"
import script from "./DNSProcessErrorContainer.vue?vue&type=script&lang=js&"
export * from "./DNSProcessErrorContainer.vue?vue&type=script&lang=js&"
import style0 from "./DNSProcessErrorContainer.vue?vue&type=style&index=0&id=3a3f833d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f833d",
  null
  
)

export default component.exports